module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch11"
    }
  }, [_c('b', [_vm._v("Death…")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Mark Twain was born in 1835, a year that Halley’s Comet was visible from Earth. As an adult, he predicted he would also die in a year that the comet made an appearance. He did, in 1910.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Hair and fingernails do not grow after death. Skin recedes, making them appear longer.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1995, inmates on death row in Texas protested because the state had banned smoking in prisons.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("“Old age” hasn’t been allowed on death certificates in the United States as an official cause of death since 1951.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Thorton’s Mortuary in Atlanta, Georgia, opened the first drive-through funeral parlor in 1968. Mourners drove past a large window, through which they could see the deceased.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("After her husband Albert died in 1861, Queen Victoria slept with a portrait of him on the pillow next to her.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('b', [_vm._v("…and Taxes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The simplest U.S. tax form (the 1040EZ) has more than 30 pages of instructions.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The U.S. tax code contains more than 7 million words.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Many states require people to pay taxes on illegal drug sales.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1798, the United States instituted its first property tax on land, homes…and slaves.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("There are twice as many U.S. tax preparers as police officers.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In Alabama, there’s a 10¢ tax on playing cards.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7656fb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter11.vue
// module id = 105
// module chunks = 0